<template>
  <div class="news">
    <div class="news-col">
      <h2>{{ $t('news.title') }}</h2>
      <div class="news-col-screenBtn" @click="handlePickerBtn('entry')">{{ $t('news.filter') }}</div>
    </div>
    <div :class="['news-regioBrand', pickerState ? 'picker-entry' : 'picker-out']">
      <div class="news-regioBrand-box">
        <h3>{{ $t('region') }}</h3>
        <ul ref="ulRegio" v-if="!loadingShow">
          <li>
            <label :class="allRegioChecked ? 'current' : ''" @change="checkboxRegioAllCl()">
              <input class="checkbox-input" type="checkbox" :value="$t('allRegions')" v-model="allRegioChecked" />
              <span class="checkbox-label">{{ $t('allRegions') }}</span>
              <span :class="['checkbox-box']"><span class="checkbox-tick iconfont">&#xe60e;</span></span>
            </label>
          </li>
          <li v-for="item in regionList" :key="item.id">
            <label @change="checkboxRegioCl($event, item.id)">
              <input class="checkbox-input" type="checkbox" :value="item.id" v-model="pickedRegio" />
              <span class="checkbox-label">{{ $store.state.locale == 'en' ? item.enName : item.name }}</span>
              <span :class="['checkbox-box']"><span class="checkbox-tick iconfont">&#xe60e;</span></span>
            </label>
          </li>
        </ul>

        <ul class="skeleton" v-if="loadingShow">
          <li v-for="(item, index) in 3" :key="index">
            <label>
              <span class="checkbox-label"><span>DOMEDOME</span></span>
              <span class="checkbox-box"></span>
            </label>
          </li>
        </ul>
      </div>
      <div class="news-regioBrand-box">
        <h3>{{ $t('brand') }}</h3>
        <ul ref="ulBrandAll" style="height: auto !important;" v-if="!loadingShow">
          <li>
            <label :class="allBrandChecked ? 'current' : ''" @change="checkboxBrandAllCl()">
              <input class="checkbox-input" type="checkbox" :value="$t('allBrands')" v-model="allBrandChecked" />
              <span class="checkbox-label">{{ $t('allBrands') }}</span>
              <span :class="['checkbox-box']"><span class="checkbox-tick iconfont">&#xe60e;</span></span>
            </label>
          </li>
        </ul>
        <ul ref="ulBrand" class="news-regioBrand-box-ul" v-if="!loadingShow">
          <li v-for="(item, index) in brandList" :key="index">
            <label @change="checkboxBrandCl($event)">
              <input class="checkbox-input" type="checkbox" :value="item.id" :key="item.id" v-model="pickedBrand" />
              <span class="checkbox-label">{{
                $store.state.locale == 'en' && item.brandCode ? item.brandCode :
                  $store.state.locale == 'tc' && item.brandNameHk ? item.brandNameHk : item.brandName
              }}</span>
              <span :class="['checkbox-box']"><span class="checkbox-tick iconfont">&#xe60e;</span></span>
            </label>
          </li>
        </ul>

        <ul class="skeleton" style="height: auto !important;" v-if="loadingShow">
          <li>
            <label>
              <span class="checkbox-label"><span>DOMEDOME</span></span>
              <span class="checkbox-box"></span>
            </label>
          </li>
        </ul>
        <ul class="news-regioBrand-box-ul skeleton-ul" v-if="loadingShow">
          <li v-for="(item, index) in 12" :key="index">
            <label>
              <span class="checkbox-label"><span>DOMEDOME</span></span>
              <span class="checkbox-box"></span>
            </label>
          </li>
        </ul>

      </div>
      <em class="iconfont" v-if="pickerState" @click="handlePickerBtn('out')">&#xe60f;</em>
    </div>

    <!-- <div class="news-regioBrand news-regioBrand-skeleton">
      <div class="news-regioBrand-box">
        <h3>品牌</h3>
        <ul>
          <li><label></label></li>
        </ul>
        <ul>
          <li v-for="item in 11"><label></label></li>
        </ul>
      </div>
    </div> -->

    <div class="news-regioBrandBg" v-if="pickerState" @click="handlePickerBtn('out')"></div>
    <div class="news-box">

      <!-- <vue-lazy-component @init="ceshi"
                          @before-init="ceshi2"
                          @after-init="ceshi3()"
                          @before-enter="ceshi4()"
                          @before-leave="ceshi5"
                          @after-leave="ceshi6"> -->

      <vue-lazy-component :timeout="100">
        <NewsList :list="newsList" keep-alive>
        </NewsList>
        <NewsListBg slot="skeleton"></NewsListBg>
      </vue-lazy-component>
      <div class="morea text-align-center" @click="handlePages()" v-if="totalState">
        <a class="morea-btn">{{ $t('news.more') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { reqGetZoneList, reqGetBrandList, reqGetArticleList } from '../../utils/api'
import NewsList from '@/components/NewsList'
import NewsListBg from '@/components/NewsListBg'

export default {
  name: 'News',
  components: {
    NewsList,
    NewsListBg
  },
  data() {
    return {
      show: false,
      // currentTab: 'all',
      allRegioChecked: false,
      allBrandChecked: false,
      loadingShow: false,
      loadingShowBrand: false,
      loadingShowNews: 50000,

      pickedRegio: [],
      pickedBrand: [],

      regionList: [],
      brandList: [],
      newsList: [],

      pickerState: false,
      // myLocation: 1,

      currentPage: 1,
      pageSize: 6,
      totalState: false
    }
  },
  mounted() {
    this.loadingShow = true
    setTimeout(() => {
      this.getLocale(this.$store.state.locale)
    }, 0)
  },
  methods: {
    getLocale(s) {
      let that = this
      let e = s == 'tc' ? 1 : s == 'sc' ? 2 : 1
      that.regionSelected(e)
    },

    async getNewsList() {

      let data = {
        home: true, // true只查发布文章
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        // zone: e.constructor === Number ? [e] : e
        zone: this.pickedRegio,
        brandId: this.pickedBrand
      }
      let res = await reqGetArticleList(data)
      this.loadingShowNews = 0
      if (this.currentPage == 1) {
        this.newsList = res.data.data
        this.total = res.data.data.total
      } else {
        res.data.data.list.forEach(v => {
          this.newsList.list.push(v)
        })
      }

      if (this.newsList.list.length >= this.total) {
        this.totalState = false
      } else {
        this.totalState = true
      }

    },

    async regionSelected(e) {
      let res = await reqGetZoneList()
      this.regionList = res.data.data
      this.loadingShow = false
      // this.regionList.push(res.data.data[0])
      this.$nextTick(() => {
        if (this.$refs.ulRegio === undefined) return false
        let ulRegio = this.$refs.ulRegio.getElementsByTagName('label')
        this.allBrandChecked = true
        this.allRegioChecked = false
        this.checkboxRegioAllCl()
        if (e === 0) {
          this.allRegioChecked = true
          this.checkboxRegioAllCl()
        } else {
          ulRegio[e].firstElementChild.checked = true
          ulRegio[e].classList.add('current')
          this.pickedRegio.push(ulRegio[e].firstElementChild.value * 1)
          // this.brandSelected(this.myLocation)
        }
      })
    },

    async brandSelected(e) {
      this.loadingShowBrand = true
      this.newsList = []
      this.brandList = []
      let zone = ''
      if (e == 1) {
        zone = 'HKMACAU';
      } else if (e == 4) {
        zone = 'MAINLAND';
      } else if (e == 19) {
        zone = 'Malaysia';
      } else {
        zone = null
      }
      console.log('e', e, zone)

      let data = {
        status: [1],
        zone: zone
      }
      let res = await reqGetBrandList(data)
      this.loadingShowBrand = false
      this.brandList = res.data.data
      this.$nextTick(() => {
        this.checkboxBrandAllCl()
        // this.getNewsList()
      })
    },

    checkboxRegioAllCl() {
      let ulRegio = this.$refs.ulRegio.getElementsByTagName('label')
      if (this.allRegioChecked) {
        this.pickedRegio = []
        this.regionList.forEach((v, i) => {
          this.pickedRegio.push(v.id)
          ulRegio[i + 1].classList.add('current')
        })
      } else {
        this.regionList.forEach((v, i) => {
          ulRegio[i + 1].classList.remove('current')
        })
        this.pickedRegio = []
      }
      console.log('eAAAAAAAAA', this.pickedRegio)
      this.newsList = []
      this.currentPage = 1
      // this.getNewsList()
    },
    checkboxRegioCl(e) {
      let checked = e.target.checked
      this.pickedRegio = []

      console.log('BBBBBBBBB', e.target, this.allRegioChecked, e.target.value)

      let ulRegio = this.$refs.ulRegio.getElementsByTagName('label')
      this.regionList.forEach((v, i) => {
        ulRegio[i + 1].classList.remove('current')
      })
      if (!this.allRegioChecked) checked = true
      if (e.type == 'change') {
        if (checked == true) {
          e.target.parentElement.classList.add('current')
          this.pickedRegio.push(e.target.value * 1)

        } else if (checked == false) {
          e.target.parentElement.classList.remove('current')
        }
        this.newsList = []
        this.currentPage = 1
        // this.getNewsList()
      }
      console.log('BBBBBBBBB222222', this.pickedRegio)

    },


    checkboxBrandAllCl() {
      if (this.$refs.ulBrandAll === undefined) return false
      if (this.$refs.ulBrand === undefined) return false
      let ulBrandAll = this.$refs.ulBrandAll.getElementsByTagName('label')
      let ulBrand = this.$refs.ulBrand.getElementsByTagName('label')

      if (this.allBrandChecked) {
        this.pickedBrand = []
        this.brandList.forEach((v, i) => {
          this.pickedBrand.push(v.id)
          ulBrand[i].classList.add('current')
        })
        ulBrandAll[0].classList.add('current')
      } else {
        this.brandList.forEach((v, i) => {
          ulBrand[i].classList.remove('current')
        })
        ulBrandAll[0].classList.remove('current')
        this.pickedBrand = []
      }
      this.newsList = []
      this.currentPage = 1
      this.getNewsList()
    },
    checkboxBrandCl(e) {
      if (e.type == 'change') {
        if (e.target.checked == true) {
          e.target.parentElement.classList.add('current')
        } else if (e.target.checked == false) {
          e.target.parentElement.classList.remove('current')
        }
      }
      this.newsList = []
      this.currentPage = 1
      this.getNewsList()
    },

    handlePickerBtn(val) {
      val == 'entry' ? this.pickerState = true : this.pickerState = false;
    },
    handlePages() {
      this.currentPage = this.currentPage + 1
      this.getNewsList()
    }
  },
  watch: {
    '$store.state.locale': {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getLocale(newVal)
        }
      },
      deep: false
    },

    pickedRegio: {
      handler(newVal, oldVal) {
        console.log('newVal', newVal)
        if (this.pickedRegio.length == this.regionList.length) {
          this.allRegioChecked = true
        } else {
          this.allRegioChecked = false
        }
        console.log('this.pickedRegio[0]', this.pickedRegio[0])
        if (this.pickedRegio.length == 3) {
          this.brandSelected('')
        } else if (this.pickedRegio.length == 0) {
          this.brandList = []
        } else if (this.pickedRegio.length == 1) {
          this.brandSelected(this.pickedRegio[0])
        }
      },
      deep: true
    },
    pickedRegio() {
      if (this.pickedRegio.length == this.regionList.length) {
        this.allRegioChecked = true
      } else {
        this.allRegioChecked = false
      }
      console.log('this.pickedRegio[0]', this.pickedRegio[0])
      if (this.pickedRegio.length == 3) {
        this.brandSelected('')
      } else if (this.pickedRegio.length == 0) {
        this.brandList = []
      } else if (this.pickedRegio.length == 1) {
        this.brandSelected(this.pickedRegio[0])
      }
    },
    pickedBrand() {
      if (this.pickedBrand.length == this.brandList.length) {
        this.allBrandChecked = true
      } else {
        this.allBrandChecked = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../static/stylebody.css";

.news {
  margin-top: 146px;

  &-col {
    &-screenBtn {
      display: none;
    }
  }

  &-regioBrand {
    padding: 18px 0 22px;
    display: flex;
    border-top: $border-top-1;
    border-bottom: $border-bottom-1;

    h3 {
      display: block;
      margin-bottom: 6px;
      font-size: 20px;
      height: 34px;
      line-height: 34px;
    }

    &-box {
      width: 300px;

      &:last-of-type {
        width: calc(100% - 300px);
      }

      &-ul {
        li {
          &:first-of-type {
            padding-left: 20px !important;
          }
        }
      }

      ul {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 3 * 34px;

        label {
          position: relative;
          font-size: 15px;
          font-weight: 300;
          cursor: pointer;
        }

        li {
          height: 34px;
          line-height: 34px;
          padding-left: 20px;

          &:first-of-type {
            padding-left: 0;
          }

          label {
            &.ban {
              .checkbox-label {
                color: #c7c9ca;
              }

              .checkbox-box {
                border: 1px solid #c7c9ca;
              }
            }

            &.current {
              .checkbox-label {
                color: $color-2;
              }

              .checkbox-box {
                background: $color-2;
                border: none;
              }
            }
          }

          .checkbox-input {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            position: absolute;
            width: 0;
            height: 0;
            overflow: hidden;
            margin: 0;
            padding: 0;
            border: 0;
            outline: 0;
            opacity: 0;
            z-index: -1;
          }

          .checkbox-label {
            margin-left: 30px;
            color: $color-grey-1;
          }

          .checkbox-box {
            display: inline-block;
            overflow: hidden;
            position: absolute;
            top: 0px;
            left: 0;
            width: 18px;
            height: 18px;
            border: 1px solid $color-grey-1;
            transition: box-shadow 0.15s linear, border 0.15s linear;
            pointer-events: none;
            z-index: 1;

            .checkbox-tick {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
              font-size: 16px;
              line-height: normal;
              color: #fff;
            }
          }
        }
      }

      .skeleton,
      .skeleton-ul {
        li {
          width: 100%;
          height: 34px;
          line-height: 34px;

          .checkbox-label {
            background: #f8f8f8;

            span {
              visibility: hidden;
            }
          }
        }
      }

      .skeleton-ul {
        li {
          width: initial;
        }
      }
    }

    em {
      display: none;
    }
  }

  &-box {
    margin: 46px 0 130px;

    .morea {
      margin-top: 140px;
    }
  }
}

@media (max-width: 1600px) {
  .news {
    margin-top: 136px;

    &-regioBrand {
      padding: 18px 0 22px;

      h3 {
        display: block;
        margin-bottom: 6px;
        font-size: 20px;
        height: 30px;
        line-height: 30px;
      }

      &-box {
        ul {
          height: 4 * 34px;

          label {
            font-size: 15px;

            .checkbox-box {
              top: 0px;
            }
          }

          li {
            height: 34px;
            line-height: 34px;

            .checkbox-label {
              margin-left: 30px;
            }
          }
        }
      }
    }

    &-box {
      margin: 40px 0 110px;

      .morea {
        margin-top: 120px;
      }
    }
  }
}

@media (max-width: 1440px) {
  .news {
    margin-top: 135px;

    // &-regioBrand {
    //   padding: 30px 0;
    //   h3 {
    //     display: block;
    //     margin-bottom: 14px;
    //     font-size: 23px;
    //     height: 36px;
    //     line-height: 36px;
    //   }
    //   &-box {
    //     ul {
    //       height: 3 * 38px;
    //       label {
    //         font-size: 17px;
    //         .checkbox-box {
    //           top: 0px;
    //         }
    //       }
    //       li {
    //         height: 38px;
    //         line-height: 38px;
    //         .checkbox-label {
    //           margin-left: 30px;
    //         }
    //       }
    //     }
    //   }
    // }
    &-box {
      margin: 38px 0 100px;

      .morea {
        margin-top: 110px;
      }
    }
  }
}

@media (max-width: 1000px) {
  .news {
    margin-top: 120px;

    // &-regioBrand {
    //   padding: 20px 0;
    //   h3 {
    //     display: block;
    //     margin-bottom: 10px;
    //     font-size: 18px;
    //     height: 34px;
    //     line-height: 34px;
    //   }
    //   &-box {
    //     ul {
    //       height: 3 * 36px;
    //       label {
    //         font-size: 15px;
    //         .checkbox-box {
    //           top: 0px;
    //         }
    //       }
    //       li {
    //         height: 36px;
    //         line-height: 36px;
    //         .checkbox-label {
    //           margin-left: 30px;
    //         }
    //       }
    //     }
    //   }
    // }
    &-box {
      margin: 36px 0 90px;

      .morea {
        margin-top: 100px;
      }
    }
  }
}

@media (max-width: 768px) {
  h2 {
    line-height: 34px;
  }

  .news {
    margin-top: 50px;
    padding: 50px 16px 0;

    &-col {
      position: relative;

      &-screenBtn {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        padding: 3px 24px;
        font-size: 14px;
        font-weight: 300;
        color: #282828;
        border: 1px solid #282828;
        cursor: pointer;
      }
    }

    &-regioBrand {
      // display: none;
      flex-direction: column;
      padding: 30px 30px 0;
      width: 100%;
      height: auto;
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 1001;
      border-top: none;
      border-bottom: none;
      border-radius: 20px 20px 0 0;

      h3 {
        display: block;
        margin-bottom: 0;
        font-size: 18px;
        height: 34px;
        line-height: 34px;
      }

      &-box {
        margin-bottom: 18px;
        width: 100%;

        &:last-of-type {
          width: 100% !important;

          ul {
            li {
              width: 33%;
            }
          }
        }

        ul {
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: wrap;
          height: auto;

          label {
            font-size: 15px;

            .checkbox-box {
              top: 0px;
            }
          }

          li {
            width: 33%;
            height: 36px;
            line-height: 36px;

            .checkbox-label {
              margin-left: 30px;
            }
          }
        }
      }

      em {
        display: block;
        padding: 15px 15px 0 0;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 18px;
        color: #ccc;
      }
    }

    &-box {
      margin: 54px 0 90px;

      .morea {
        margin-top: 100px;
      }
    }

    &-regioBrandBg {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
    }

    .picker-entry {
      // 渐入动画
      background: #fff;
      transition: 0.3s all;
      transform: translateY(0%);
      opacity: 1;
      visibility: visible;
    }

    // 渐出动画
    .picker-out {
      transition: 0.3s all;
      transform: translateY(100%);
      opacity: 0;
      visibility: hidden;
    }
  }
}

@media (max-width: 500px) {
  .news {
    &-regioBrand {
      &-box {
        &:last-of-type {
          ul {
            li {
              width: 50%;
            }
          }
        }

        ul {
          li {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/News.vue